import {Model} from "./Model";
import {IApiPager} from "../typings/apiResponse";

export interface IPager {
    getTotal(): number
    getLimit(): number
    getOffset(): number
}

export class Pager extends Model implements IPager {

    constructor(private apiData: IApiPager) {
        super(apiData);
    }

    getTotal():number {
        return this.apiData.total;
    }

    getLimit():number {
        return this.apiData.limit;
    }

    getOffset():number {
        return this.apiData.offset;
    }
}
